export async function loadOrbitMain(): Promise<void> {
    const module = await import(/* webpackChunkName: "orbit-main" */ './main');
    await module.startApplication();
}